/**
 * Công tắc tắt toast lỗi ở cấp toàn ứng dụng.
 *
 * Dùng khi màn hình đã hiển thị lỗi ở dạng TRANG (vd trang 403 khi request đọc
 * dữ liệu bị từ chối): lúc đó một loạt request song song cùng fail sẽ bắn thêm
 * hàng loạt toast chồng lên trang lỗi — vừa thừa vừa gây hiểu nhầm.
 *
 * Đặt ở helper riêng (thay vì trong toastDedup) để module patch toast không phải
 * import ngược lên tầng component.
 */
let suppressed = false;

export const setErrorToastsSuppressed = (value) => {
  suppressed = Boolean(value);
};

export const areErrorToastsSuppressed = () => suppressed;
